export default __webpack_public_path__ + "static/media/align.35cf0361.gif";